import { jsx as o } from "react/jsx-runtime";
import { a as d, F as i } from "../../index.esm-BkTadKG5.js";
function h({
  formProps: s = { mode: "onTouched" },
  onSubmit: t,
  onSubmitFail: e,
  children: m,
  formElementProps: a
}) {
  const r = d(s);
  return /* @__PURE__ */ o(i, { ...r, children: /* @__PURE__ */ o(
    "form",
    {
      ...a,
      onSubmit: (n) => {
        r.handleSubmit(t)(n).catch(async (c) => {
          e && r.setError("root.server", {
            type: "server",
            message: await e(c)
          });
        });
      },
      children: m
    }
  ) });
}
export {
  h as default
};
